// extracted by mini-css-extract-plugin
export default {"paper_dialog":"apiIntegrationPopup_paper_dialog__dwuK1","decktop":"apiIntegrationPopup_decktop__bf2Yc"};